import { t } from "i18next";
import { useEffect, useState } from "react";
import { min } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import C from "Constants";
import ConditionalRenderer from "components/ConditionalRenderer";
import { useUserWallet } from "hooks";
import { LoyaltyAction } from "store/actions";
import ApplyVoucher from "components/discounts-loyalty/ApplyVoucher";
import LoyaltyRedeemSwitch from "components/brand-loyalty/LoyaltyRedeemSwitch";
import LoyaltyCreditWidget from "components/brand-loyalty/LoyaltyCreditWidget";
import { DiscountAction } from "store/actions";
import CustomModal from "components/CustomModal";
import ConfirmModal from "components/Modals/ConfirmModal";
// import { CartAction } from "store/actions";

const DiscountLoyaltyApply = ({
  isApplyVoucherOpen,
  setIsApplyVoucherOpen = () => {},
  updateCart = () => {},
}) => {
  const dispatch = useDispatch();

  const { cart, cartTotal } = useSelector((state) => state.cart);
  const { discountInfo, isDiscountApplied } = useSelector(
    (state) => state?.Discounts
  );

  const { loyaltyApplied } = useSelector((state) => state?.Loyalty);
  const { loyaltyPolicy } = useSelector((state) => state.brandStorageReducer);

  const userWallet = useUserWallet();

  const [redeemAmount, setRedeemAmount] = useState(0);
  const [confirmModal, setConfirmModal] = useState(false);
  const [confirmationCallback, setConfirmationCallback] = useState(
    () => () => {}
  );
  const [confirmModalTitle, setConfirmModalTitle] = useState({
    title: "",
    message: "",
  });
  const [openDiscountPopup, setDiscountPopup] = useState(false);

  const switchLoyaltyStatus = () => {
    if (loyaltyApplied) {
      dispatch(LoyaltyAction.removeLoyalty());
      updateCart();
    } else {
      dispatch(LoyaltyAction.applyLoyalty(Number(redeemAmount)));
      updateCart();
    }
  };

  const handleConfirmDiscountLoyalty = (wantsToApply) => {
    if (loyaltyApplied && wantsToApply === C.DISCOUNT) {
      setConfirmModal(true);
      setConfirmModalTitle({
        title: t("Use discount code"),
        message: t(
          "To use discount code, the loyalty points will be removed. Do you want to continue"
        ),
      });

      setConfirmationCallback(() => () => {
        dispatch(LoyaltyAction.removeLoyalty());

      //TODO: uncomment this is we want to only apply the discount on the whole order and remove the discount from the cart items
        // dispatch(CartAction.removeDiscountAmountFromCartItems());
        setDiscountPopup(true);
        updateCart();
      });
    } else if (
      (isDiscountApplied || discountInfo) &&
      wantsToApply === C.LOYALTY
    ) {
      setConfirmModal(true);
      setConfirmModalTitle({
        title: t("Use loyalty credits"),
        message: t(
          "To use loyalty points, the discount code will be removed. Do you want to continue"
        ),
      });
      setConfirmationCallback(() => () => {
        dispatch(DiscountAction.setCoponValidation(false));
        dispatch(DiscountAction.removeDiscountCode());

      //TODO: uncomment this is we want to only apply the discount on the whole order and remove the discount from the cart items
        // dispatch(CartAction.removeDiscountAmountFromCartItems());
        switchLoyaltyStatus();
        updateCart();
      });
    } else if (wantsToApply === C.LOYALTY) {
      switchLoyaltyStatus();
    } else if (wantsToApply === C.DISCOUNT) {
      setDiscountPopup(true);
    }
  };

  const handleConfirmModal = () => {
    setConfirmModal(false);
    confirmationCallback();
  };

  const handleCancelModal = () => {
    setConfirmModal(false);
    setIsApplyVoucherOpen(false);
    setDiscountPopup(false);
  };

  const calculateRedeemAmount = () => {
    const maxRedeemableValuePerOrder =
      loyaltyPolicy?.maxRedeemableValuePerOrder || 0;
    const redeemablePercentagePerOrder =
      loyaltyPolicy?.redeemablePercentagePerOrder || 0;
    const redeemableAmount = Number(
      (cartTotal / 100) * redeemablePercentagePerOrder
    );
    let minimum = min([
      maxRedeemableValuePerOrder,
      redeemableAmount,
      userWallet,
    ])?.toFixed(2);
    setRedeemAmount(Number(minimum));
    updateCart();
    dispatch(LoyaltyAction.updateloyaltyAmount(Number(minimum)));
  };

  useEffect(() => {
    calculateRedeemAmount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartTotal, loyaltyPolicy, cart, userWallet]);

  useEffect(() => {
    if (isApplyVoucherOpen) {
      handleConfirmDiscountLoyalty(C.DISCOUNT);
    }
  }, [isApplyVoucherOpen]);

  return (
    <>
      <ConditionalRenderer
        condition={loyaltyPolicy?.isLoyaltyActive && userWallet > 0}
      >
        <LoyaltyRedeemSwitch
          switchLoyaltyStatus={() => handleConfirmDiscountLoyalty(C.LOYALTY)}
          redeemAmount={redeemAmount}
          wrapperStyleProps={{
            className: "justify-between",
            style: {
              flexDirection: "row-reverse",
            },
          }}
          textStyleProps={{
            className: "flex gap-1 flex-wrap text-16x font-medium",
          }}
        />
        {loyaltyApplied && (
          <LoyaltyCreditWidget
            {...{ loyaltyPolicy }}
            containerStyleProps={{
              style: { margin: "0px" },
            }}
          />
        )}
      </ConditionalRenderer>
      <ApplyVoucher
        isOpen={openDiscountPopup}
        onClose={() => {
          setIsApplyVoucherOpen(false);
          setDiscountPopup(false);
        }}
      />
      <CustomModal
        open={confirmModal}
        setOpen={setConfirmModal ?? (() => {})}
        bodyclasses="flex"
        overlayClasses="fixed h-screen w-screen top-0 bg-opacity-50 overflow-hidden transition ease-linear duration-700 z-40 "
      >
        <ConfirmModal
          onConfirm={handleConfirmModal ?? (() => {})}
          onCancel={handleCancelModal ?? (() => {})}
          title={confirmModalTitle}
        />
      </CustomModal>
    </>
  );
};

export default DiscountLoyaltyApply;
